import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppConfiguration } from '@models';
import { catchError, debounceTime, map, Observable, of, startWith, switchMap } from 'rxjs';
import { ApiService } from './api-service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiService);

  /**
   * Event currency name from the backend ("Shopping Dollars"). The endpoint needs the player token, so it is
   * empty until sign-in, on error and in admin-panel; prices then show without a unit rather than a hardcoded one.
   */
  readonly rewardName = toSignal(
    this.authService.tokenChanges$.pipe(
      startWith(null),
      debounceTime(10),
      switchMap(() => (this.authService.token ? this.getRewardName() : of(''))),
    ),
    { initialValue: '' },
  );

  // Never rethrow: an errored stream would kill the `rewardName` toSignal.
  private getRewardName(): Observable<string> {
    return this.apiService.get<AppConfiguration>('configuration').pipe(
      map((configuration) => configuration?.rewardName?.trim() ?? ''),
      catchError(() => of('')),
    );
  }
}
